import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import './i18n'
import { CommonDataProvider } from 'contexts/CommonDataContext/CommonDataProvider';
import { ExternalUrlsProvider } from 'contexts/ExternalUrlsContext';
import RecaptchaProviderWrapper from './components/RecaptchaProviderWrapper';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <RecaptchaProviderWrapper>
        <ExternalUrlsProvider>
        <Layout>
          <Routes>
            {AppRoutes.map((route, index) => {
              const { element, ...rest } = route;
              return <Route key={index} {...rest} element={<CommonDataProvider>{element}</CommonDataProvider>} />;
            })}
          </Routes>
        </Layout>
        </ExternalUrlsProvider>
      </RecaptchaProviderWrapper>
    );
  }
}
